'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _capeRouterComponent = require('cape-router-component');

var _capeFirebase = require('cape-firebase');

var _capeFirebase2 = _interopRequireDefault(_capeFirebase);

var _configureStore = require('./configureStore');

var _configureStore2 = _interopRequireDefault(_configureStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window */

// @param initState Define our inital state object.
// This could be a fetch() to an API endpoint or something saved to window.reactData for example.
function init(initialState, RouteIndex) {
  var firebase = (0, _capeFirebase2.default)((0, _capeFirebase.getConfig)(initialState));
  // Configure and create our Redux store.
  var store = (0, _configureStore2.default)(initialState, firebase);

  // Define our destination where we insert our root react component.
  var rootDestEl = window.document.getElementById('root');

  (0, _capeRouterComponent.renderRoot)({ rootDestEl: rootDestEl, RouteIndex: RouteIndex, store: store });
  return {
    firebase: firebase,
    store: store
  };
}
// Redux code to build store.
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-react-app/lib/init.js
// module id = 702
// module chunks = 0